import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import MyModal from 'helpers/MyModal.js';
import React, { useEffect, useState } from 'react';
import FormatosQuejaTable from './_FormatosQuejaTable.js';
import EditFormatoQueja from './_EditFormatoQueja.js';
const URI = ApiEndpoint + 'administration/';
const FormatosQueja = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [formatosQueja, setFormatosQueja] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [idFormatoQuejaEdit, setIdFormatoQuejaEdit] = useState(null);

  const handleClose = () => {
    setOpenModal(false);
    getFormatosQueja();
  };

  const getFormatosQueja = async () => {
    setFormatosQueja(null);

    httpClient('GET', URI + 'formatosqueja', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setFormatosQueja(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    getFormatosQueja();
  }, []);
  return (
    <>
      {formatosQueja && (
        <FormatosQuejaTable
          formatosQueja={formatosQueja}
          setOpenModal={setOpenModal}
          setIdFormatosQueja={setIdFormatoQuejaEdit}
        ></FormatosQuejaTable>
      )}
      {openModal && (
        <MyModal
          id="id_myModal"
          title={
            (idFormatoQuejaEdit > 0 ? 'Editar' : 'Agregar') +
            ' Formatos de Queja'
          }
          openModal={openModal}
          closeModal={handleClose}
        >
          <EditFormatoQueja
            idFormatosQueja={idFormatoQuejaEdit}
            closeModal={handleClose}
          ></EditFormatoQueja>
        </MyModal>
      )}
    </>
  );
};

export default FormatosQueja;
